import * as localforage from 'localforage';

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
import { appReducers } from './reducers/index';
import { baseApi } from './store/api/baseApi';

const reducer = combineReducers({
	...appReducers,
	[baseApi.reducerPath]: baseApi.reducer,
});

const persistConfig: PersistConfig<ReturnType<typeof reducer>> = {
	key: 'root',
	version: 1,
	storage: localforage,
	whitelist: ['pendingApprovalChatList', 'pushNotifReducer'],
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		}).concat(baseApi.middleware),
	devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;
